/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type ScaleTransactionStatus = typeof ScaleTransactionStatus[keyof typeof ScaleTransactionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScaleTransactionStatus = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  WAIT_DISBURSEMENT: 'WAIT_DISBURSEMENT',
  WAIT_PAYMENT: 'WAIT_PAYMENT',
  CONFIRMED: 'CONFIRMED',
  PERFORMING_PAYMENT: 'PERFORMING_PAYMENT',
  WAIT_PAYMENT_CONFIRMATION: 'WAIT_PAYMENT_CONFIRMATION',
  ERROR_DURING_PAYMENT: 'ERROR_DURING_PAYMENT',
} as const;
